import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class ProductSettingsService {

  constructor(private api: ApiService) {
  }

  getList() {
    return this.api.get('/admin/product-settings').pipe(map(({result}) => result));
  }

  update(productId: number, key: string, value: string) {
    return this.api.post('/admin/product-settings', {
      productId,
      key,
      value
    }).pipe(map(({result}) => result));
  }

  delete(productSetting) {
    if (productSetting) {
      return this.api.delete('/admin/product-settings/' + productSetting.id).pipe(map(response => response));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-services/product-settings.service.ts